module.exports = __webpack_public_path__ + "img/160039.a0d8e30f.png";